import { createFileRoute } from "@tanstack/react-router"
import { RestrictedStatesSettingsPage } from "@/features/settings/components/restricted-states-settings-page"
import { requireSuperAdminRouteAccess } from "@/features/authz/require-super-admin-route-access"
export const Route = createFileRoute("/dashboard/settings/restricted-states/")({
	component: RestrictedStatesSettingsPage,
	beforeLoad: async ({ context }) => { await requireSuperAdminRouteAccess(context.queryClient) },
})
